module.exports = __webpack_public_path__ + "static/CosmicForces-82f833e8e18358158d6199fb89445294.png";